module.exports = __webpack_public_path__ + "img/humedad_white.3900c272.svg";